var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhrLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 533.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef476f;}.cls-2{fill:#32bfa3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.17,266.9a66.72,66.72,0,0,0,66.72,66.72V200.18a66.72,66.72,0,0,0-66.72,66.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,266.9C0,414.3,119.5,533.79,266.89,533.79V405.58a5.3,5.3,0,0,0-5.06-5.33,133.45,133.45,0,0,1,0-266.7,5.31,5.31,0,0,0,5.06-5.33V0C119.5,0,0,119.49,0,266.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.33,528.45V400.35A133.44,133.44,0,0,1,466.78,533.8H338.67a5.35,5.35,0,0,1-5.34-5.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.33,0A133.45,133.45,0,0,1,466.78,133.45V266.89A133.44,133.44,0,0,1,333.33,133.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M600.23,266.9c147.4,0,266.89,119.49,266.89,266.89H738.91a5.33,5.33,0,0,1-5.34-5.06A133.43,133.43,0,0,0,600.23,400.35,133.46,133.46,0,0,1,466.77,266.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1199.94,261.48C1197.1,119,1082.6,3.89,940.36.1a7.13,7.13,0,0,0-7.26,7.14V133.45A133.45,133.45,0,0,1,1066.55,266.9h128a5.34,5.34,0,0,0,5.35-5.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1066.55,266.9H933.1c0,147.4,119.49,266.89,266.9,266.89V400.35A133.45,133.45,0,0,1,1066.55,266.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M733.67,133.45V0A133.45,133.45,0,0,1,867.12,133.45V266.9A133.45,133.45,0,0,1,733.67,133.45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhrLogoShort);
export default __webpack_public_path__ + "static/media/ehr-logo-short.c72e5e28ad351c63b95d51a155cf4f45.svg";
export { ForwardRef as ReactComponent };